export default "__VITE_ASSET__BW9dX5aZ__"